import { Collection } from 'modules/core/lib/mobx-rest'

import Message from 'modules/ats/store/models/Message'

export interface BulkEmailParams {
  job_application_ids: number[]
  content: string
  send_as_corporate_email?: boolean
  delayed_until?: string
}

export interface CancelDelayedMessageParams {
  message_id: number
}

class Messages extends Collection<Message> {
  get cacheKey(): string {
    return 'messages'
  }

  model() {
    return Message
  }

  async bulkCreate(data: BulkEmailParams) {
    return this.rpc('bulk_create', data)
  }

  async cancel(data: CancelDelayedMessageParams) {
    return this.rpc('cancel', data)
  }
}

const singleton: Messages = new Messages()

export default singleton
